// When charts are side by side, their tooltip disappears behind the adjacent chart
// Increases the z-index of the containing adjoining container to prevent that from happening

const zIndexOnHover = () => {
  let cols = document.querySelectorAll('[data-hover-z-index]');

  if (cols) {
    cols.forEach(el => {
      el.addEventListener('mouseover', (evt) => {
        let col = evt.target.closest('div[data-hover-z-index]');

        if (!col) {
          return null;
        }

        col.classList.add('is-higher');
      });

      el.addEventListener('mouseout', (evt) => {
        let col = evt.target.closest('div[data-hover-z-index]');

        if (!col) {
          return null;
        }

        col.classList.remove('is-higher');
      });
    });
  }
}

// Init on intial page load
zIndexOnHover();
